import './filters.scss';

export default () => {
	// Js-click-toggle
	$( '.filters__filter-text' ).click( function ( e ) {
		e.preventDefault();
		$( this ).next().slideToggle();
	} );

	function loadVacancies ( category ) {
		// Show loading indicator
		// $('.jobs').html('<div class="grid-container"><div class="grid-x grid-margin-x"><div class="loading">Loading...</div></div></div>');

		$.ajax( {
			url: '/wp/wp-admin/admin-ajax.php',
			type: 'GET',
			data: {
				action: 'filter_vacancies',
				category: category,
			},
			success: function ( response ) {
				if ( response.success ) {
					$( '.jobs' ).html( response.data );
				} else {
					$( '.jobs' ).html( '<div class="grid-container"><div class="grid-x grid-margin-x"><div class="error">Er is iets misgegaan. Probeer het alstublieft opnieuw.</div></div></div>' );
				}
			},
			error: function ( xhr, status, error ) {
				console.error( 'AJAX Error:', error );
				$( '.jobs' ).html( '<div class="grid-container"><div class="grid-x grid-margin-x"><div class="error">Er is iets misgegaan. Probeer het alstublieft opnieuw.</div></div></div>' );
			},
		} );
	}
	// Handle filter link clicks
	$( '.filter-link' ).click( function ( e ) {
		e.preventDefault();
		const category = $( this ).data( 'category' );

		// Update active state
		$( '.all-vacancies-link' ).removeClass( 'active' ).attr( 'aria-current', 'false' );
		$( '.filter-link' ).removeClass( 'active' ).attr( 'aria-current', 'false' );
		$( this ).addClass( 'active' ).attr( 'aria-current', 'true' );

		loadVacancies( category );
	} );

	// Handle "Alle vacatures" (All vacancies) button click
	$( '.all-vacancies-link' ).click( function ( e ) {
		e.preventDefault();

		// Update active state for the "Alle vacatures" button
		$( '.filter-link' ).removeClass( 'active' ).attr( 'aria-current', 'false' ); // Optional: You can keep this if you want to remove active state from all filters
		$( this ).addClass( 'active' ).attr( 'aria-current', 'true' ); // Set active state for "Alle vacatures"

		// Load all vacancies by passing 'all' to the loadVacancies function
		loadVacancies( 'all' );
	} );
};
